import { render, staticRenderFns } from "./AddBaseIdsComponent.vue?vue&type=template&id=72888d3e&scoped=true"
import script from "./AddBaseIdsComponent.vue?vue&type=script&lang=js"
export * from "./AddBaseIdsComponent.vue?vue&type=script&lang=js"
import style0 from "./AddBaseIdsComponent.vue?vue&type=style&index=0&id=72888d3e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72888d3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72888d3e')) {
      api.createRecord('72888d3e', component.options)
    } else {
      api.reload('72888d3e', component.options)
    }
    module.hot.accept("./AddBaseIdsComponent.vue?vue&type=template&id=72888d3e&scoped=true", function () {
      api.rerender('72888d3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/modules/use_cases/components/AddBaseIdsComponent.vue"
export default component.exports